module.exports = __webpack_public_path__ + "img/album15_09.1e45ea11.jpg";